import React from 'react';
import PropTypes from 'prop-types';
import { productItemShape } from '../shapes';
import Checkbox from '../../../../common/Checkbox';

const ProductItem = ({ product, checked, onChange }) => (
  <div className="c-table-card__row c-table-card__row--transparent">
    <div className="c-table-card__cell u-2/10">
      <Checkbox name={product.id} checked={checked} onChange={onChange} />
    </div>
    <div className="c-table-card__cell u-4/10">{product.name}</div>
    <div className="c-table-card__cell u-4/10">
      {product.category}
    </div>
  </div>
);

ProductItem.propTypes = {
  product: productItemShape.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

ProductItem.defaultProps = {
  checked: false,
  onChange: undefined,
};

export default ProductItem;
